// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"304":"Busquedas","582":"Portales"}[chunkId] || chunkId) + "." + {"126":"67b3e565","304":"278a5dc6","345":"12f9a3fd","515":"a768519c","535":"d5c7ee56","582":"afafa678"}[chunkId] + ".css";
};